import React, { memo, useMemo, useContext } from 'react';
import { object, string } from 'prop-types';
import { Link } from 'react-router-dom';
import classNames from 'classnames/bind';

import { StaticTextContext } from 'context/StaticTextContext';
import { currentLanguage } from 'utils/currentLanguage';
import { withErrorBoundary } from 'containers/ErrorBoundary';
import styles from './Breadcrumbs.module.scss';

const cx = classNames.bind(styles);

const getTitles = (obj) => {
  let newObj = {};
  for (let key in obj) {
    newObj[key] = newObj[key] || {};
    newObj[key].title = obj[key];
  }

  return newObj;
};

const getBreadcrumbs = (data, titles) => {
  let breadcrumbs = [];

  for (let key in data) {
    breadcrumbs.push(Object.assign({}, data[key], titles[key]));
  }

  return breadcrumbs.sort((a, b) => a.id - b.id);
};

const Breadcrumbs = ({ data, className }) => {
  const { labels } = useContext(StaticTextContext);
  const titles = getTitles(labels.breadcrumbs);
  const breadcrumbs = useMemo(() => getBreadcrumbs(data, titles), [
    data,
    titles,
  ]);

  return (
    <ul className={cx('breadcrumbs', className)} itemscope="" itemtype="https://schema.org/BreadcrumbList">
      <li className={cx('item')} itemscope="" itemprop="itemListElement" itemtype="https://schema.org/ListItem">
        <a className={cx('link')} href={`/${currentLanguage}`} itemprop="item">
          <span itemprop="name">{labels.breadcrumbs.home}</span>
        </a>
        <meta itemprop="position" content="1" />
      </li>
      {breadcrumbs.map((item, index) => (
        <li className={cx('item')} key={item.id} itemscope="" itemprop="itemListElement" itemtype="https://schema.org/ListItem">
          {!item.active ? (
            <Link className={cx('link')} to={item.url} itemprop="item">
              <span itemprop="name">{item.title}</span>
            </Link>
          ) : (
            <span itemprop="name">{item.title}</span>
          )}
          <meta itemprop="position" content={index + 2} />
        </li>
      ))}
    </ul>
  );
};

Breadcrumbs.propTypes = {
  data: object.isRequired,
  className: string,
};

Breadcrumbs.defaultProps = {
  className: null,
};

export default memo(withErrorBoundary(Breadcrumbs));



// WEBPACK FOOTER //
// ./src/components/Breadcrumbs/Breadcrumbs.js